$(function(){
    if ($('[data-accordion]').length > 0) {
        $('[data-accordion]').on('click', function(){
            const target = '#' + $(this).data('accordion');
            $(this).toggleClass('active');
            $(target).toggleClass('visible');
        });
    }
})